/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconForward: {
  name: 'forward';
  data: string;
} = {
  name: 'forward',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="m658.084 698.992-526.337 2.471S338.191 207.1 333.878 194.236l-61.674-.3 125.27-95.066 127.318 96.813-67.215.3 200.507 503.009z" transform="translate(-46.994 -51.688) scale(.89385)"/></svg>`,
};
